import { api } from 'data/api/api'

export const resolveComplaint = (id: string) => api.post(`/complaints/${id}/resolve`)
